import React from "react";

import {
    Box,
    Dialog,
    Typography,
    Button,
    Link
} from "@mui/material";

import { useTranslation } from 'react-i18next';
import MaskSelectorToolStyles from "./MaskSelectorToolStyles";
import {isNextGenEnabled} from "../../AppSettings";
import PropTypes from "prop-types";

const NoCameraAccessDialog = ({
                                  open,
                                  handleClose,
                                  handleTryManualMeasure,
                                  handleOKButton,
                                  displayManualMeasureLink,
                              }) => {
    const { classes: commonClasses } = MaskSelectorToolStyles();

    const { t } = useTranslation("pages.MaskSelectorTool.NoCameraAccessDialog");

    // Localization Strings
    const mainMessage = t("mainMessage");
    const manualMeasureLink = t("manualMeasureLink");
    const closePopupButton = t("closePopupButton");

    // Next gen modal
    const noCameraAccess = t("noCameraAccess");
    const checkBrowserSettings = t("checkBrowserSettings");

    return (
      <Dialog open={open} onClose={handleClose}>
          <Box maxWidth="335px" height={"232px"} className={commonClasses.optionCardPopupBox}>
              {isNextGenEnabled() ? (
                <Box pt={2} px={"24px"}>
                    <Box>
                        <Typography
                          sx={{ fontSize: 24, color: "#212121" }}
                          tabIndex="0"
                          aria-label={mainMessage}
                        >
                          {noCameraAccess}
                        </Typography>

                        <Typography
                          sx={{ fontSize: 16, color: "#424243" }}
                          tabIndex="0"
                          mt={2}
                          aria-label={mainMessage}
                        >
                          {checkBrowserSettings}
                        </Typography>
                    </Box>

                    <Box
                      mt={4}
                      mb="22px"
                      sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                      }}
                    >
                        <Button
                          disableRipple
                          variant="contained"
                          color="secondary"
                          onClick={handleOKButton}
                        >
                            {closePopupButton}
                        </Button>

                        {displayManualMeasureLink && (
                          <Link
                            href="#"
                            onClick={handleTryManualMeasure}
                            sx={{
                                fontSize: 13,
                                fontWeight: 600,
                                textDecoration: "none",
                                color: "#006DB7",
                            }}
                          >
                              {manualMeasureLink}
                          </Link>
                        )}
                    </Box>
                </Box>
              ) : (
                <Box p={2} pt={4} className={commonClasses.optionCardPopupBox}>
                    <Box mt={1}>
                        <Typography
                          className={`${commonClasses.optionCardPopupText} ${commonClasses.noOutline}`}
                          tabIndex="0"
                          aria-label={mainMessage}
                        >
                            {mainMessage}
                        </Typography>
                    </Box>

                    <Box className={commonClasses.centeredBox} mt="20px" mb="22px">
                        <Button
                          disableRipple
                          variant="contained"
                          color="secondary"
                          onClick={handleOKButton}
                        >
                            {closePopupButton}
                        </Button>
                    </Box>

                    <Box
                      className={`${commonClasses.centeredBox} ${commonClasses.res_heading6}`}
                      mb="22px"
                    >
                        <Link
                          href="#"
                          onClick={handleTryManualMeasure}
                          className={commonClasses.res_standaloneLink}
                        >
                            {manualMeasureLink}
                        </Link>
                    </Box>
                </Box>
              )}
          </Box>
      </Dialog>
    );
};


NoCameraAccessDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func,
    handleTryManualMeasure: PropTypes.func.isRequired,
    handleOKButton: PropTypes.func.isRequired,
    displayManualMeasureLink: PropTypes.bool
}

export default NoCameraAccessDialog;
